module.exports = __webpack_public_path__ + "static/media/contact.7818871e.png";